import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { getPath, routeNames } from '../../shared/helpers/routes';
import { Image } from '../Image/Image';

import type { CnpTagId } from '@vgtv/api-client/lib/cnp_tag';
import type { FC } from 'react';
import type { ImageSources } from '../../helpers/images';

import * as styles from './Profile.module.scss';

// Fixme should we translate alt for image?

export interface ProfileProps {
  id?: CnpTagId;
  imageSources: ImageSources;
  name?: string;
  className?: string;
  onClick?: () => void;
}

const Profile: FC<ProfileProps> = ({
  id,
  imageSources,
  name,
  className,
  onClick,
}) => {
  const profile = (
    <div className={classNames(styles.profile, className)}>
      <Image imageSources={imageSources} className={styles.image} isRound />
      {name && <h3 className={styles.profileName}>{name}</h3>}
    </div>
  );

  return id !== undefined ? (
    <Link
      to={getPath(routeNames.tag, { tagId: id, title: name })}
      className={styles.link}
      onClick={onClick}
    >
      {profile}
    </Link>
  ) : (
    profile
  );
};

export { Profile };
